export const NEWRELIC_BROWSER_AGENT_IDENTIFIER = 'orderHistoryFragmentNRAgent';

const NEW_RELIC_LICENSE_KEY = process.env.NR_LICENSE_KEY;
const NEW_RELIC_APP_ID = process.env.NR_APP_ID;

export const NEWRELIC_AGENT_CONFIG = {
  init: {
    privacy: { cookies_enabled: true },
  }, // NREUM.init
  info: {
    beacon: 'bam.nr-data.net',
    errorBeacon: 'bam.nr-data.net',
    licenseKey: `${NEW_RELIC_LICENSE_KEY}`,
    applicationID: `${NEW_RELIC_APP_ID}`,
    sa: 1,
  }, // NREUM.info
  loader_config: {
    accountID: '2429158',
    trustKey: '1106546',
    agentID: `${NEW_RELIC_APP_ID}`,
    licenseKey: `${NEW_RELIC_LICENSE_KEY}`,
    applicationID: `${NEW_RELIC_APP_ID}`,
  }, // NREUM.loader_config
  exposed: false,
};

export const ORDERS_UI_EVENT_TYPE = 'orders-ui-event';
export const ORDERS_UI_ERROR_TYPE = 'orders-ui-error';

export const ORDER_HISTORY_TAB_CHANGED = 'orders-ui-order-history-tab-changed';

// Analytics-centric custom events.
const ANALYTICS_SUBTYPE = 'orders-ui-analytics';
export const ANALYTICS_ERROR = `${ANALYTICS_SUBTYPE}.ANALYTICS_ERROR`;

export const BUY_IT_AGAIN_PAGE_NUMBER_CHANGED =
  'orders-ui-buy-it-again-page-number-changed';
export const BUY_IT_AGAIN_PRESENTED = 'orders-ui-buy-it-again-presented';
export const BUY_IT_AGAIN_ERROR =
  'orders-ui-buy-it-again-reorderable-item-fetch-error';
export const BUY_IT_AGAIN_NO_REORDERABLE_ITEMS =
  'orders-ui-buy-it-again-no-reorderable-items-returned';
export const BUY_IT_AGAIN_CHECKOUT_CLICKED =
  'orders-ui-buy-it-again-checkout-click';
export const BUY_IT_AGAIN_QUANTITY_CHANGED =
  'orders-ui-buy-it-again-quantity-changed';

// Find order custom events
export const FIND_ORDER_ATTEMPTED = 'orders-ui-find-order-attempted';
export const FIND_ORDER_FAILED = 'orders-ui-find-order-attempt-failed';
export const FIND_ORDER_SUCCESS = 'orders-ui-find-order-attempt-success';

export const PROFILE_FETCH_ERROR = 'orders-ui-profile-fetch-error';
export const PRODUCT_REORDERED_LABEL = 'Product Re-ordered';

// doc remediation & conversion
export const LEGACY_DOCUMENT_REMEDIATION_MODAL_PRESENTED_TO_CUSTOMER =
  'Legacy Document Remediation Modal Presented To Customer';
export const ITEM_LEGACY_DOC_CONVERSION_ATTEMPTED_EVENT_NAME =
  'Item Legacy Doc Conversion Attempted';
export const LEGACY_DOCUMENT_CONVERSION_ATTEMPTED =
  'orders-ui-legacy-document-conversion-attempted';
export const LEGACY_DOCUMENT_CONVERSION_SUCCEEDED =
  'orders-ui-legacy-document-conversion-succeeded';
export const LEGACY_DOCUMENT_CONVERSION_FAILED =
  'orders-ui-legacy-document-conversion-failed';

export const DOC_CONVERSION_FAILURE = 'DOC_CONVERSION_FAILURE';
export const LEGACY_EDIT_DOCUMENT_URL_CONVERSION_SUCCESS_EVENT_NAME =
  'Legacy Product Edit Document URL retrieved';

// Reorder custom events
export const REORDER_ATTEMPTED = 'orders-ui-reorder-attempted';
export const REORDER_FAILED = 'orders-ui-reorder-attempt-failed';
export const REORDER_SUCCESS = 'orders-ui-reorder-attempt-success';
export const DOC_CONVERSION_MODAL_PRESENTED_TO_CUSTOMER =
  'orders-ui-legacy-doc-conversion-modal-presented';

// Reorder failure reasons
export const REORDER_UNAVAILABLE_FOR_PRODUCT =
  'orders-ui-reorder-unavailable-for-product';
export const PRODUCT_KEY_MISSING = 'PRODUCT_KEY_MISSING';
export const REORDER_NOT_PERMITTED = 'REORDER_NOT_PERMITTED';
export const RETIRED_PRODUCT = 'RETIRED_PRODUCT';
export const IS_REORDERABLE_FALSE = 'IS_REORDERABLE_FALSE';

// Action strings
export const EDIT_ACTION = 'EDIT';
export const REORDER_ACTION = 'REORDER';
export const EXPRESS_CHECKOUT_ACTION = 'EXPRESS_CHECKOUT';

export const DOCUMENT_EDIT_CLICKED = 'orders-ui-doc-edit-click';

// TODO: add to NR dashboard or remove?
export const DOCUMENT_URL_FETCH_FAILED = 'orders-ui-document-url-fetch-failed';

// reorder
export const ORDER_ITEMS_REORDERED_ATTEMPTED_EVENT_NAME =
  'Order Reorder Attempted';
export const EXPRESS_CHECKOUT_ADDED_TO_CART_EVENT_NAME =
  'Express Checkout Product Added To Cart';

export const MY_ACCOUNT_PAGE_STAGE = 'My Account';

export const MY_ACCOUNT_PAGE_SECTION = 'My Account';

export const BUY_NOW_ATTEMPTED = 'orders-ui-buy-now-attempted';
export const BUY_NOW_FAILED = 'orders-ui-buy-now-attempt-failed';
export const BUY_NOW_SUCCESS = 'orders-ui-buy-now-attempt-success';
export const BUY_NOW_ADD_TO_CART_FAILED =
  'orders-ui-buy-now-add-to-cart-failed';
export const EXPRESS_CHECKOUT_ADD_TO_CART_CLICK =
  'orders-ui-express-checkout-add-to-cart-click';
